<template>
    <v-checkbox v-model="value" @change="changeValue" hide-details class="mt-0 mb-0 pa-0" />
</template>
<script>
export default {
    props: ["classificator_value", "classificator_row", "classificator_type"],
    name: "classificator-input",
    data() {
        return { value: this.classificator_value };
    },
    methods: {
        changeValue(val) {
            this.$emit("changeValue", {
                value: val,
                classificator_row: this.classificator_row,
                classificator_type: this.classificator_type
            });
        }
    }
};
</script>
<style scoped></style>
